// 005 — pares de las prescripciones emitidas con el wizard de receta, para el documento firmado (modo `msp`).
// El instructivo del MSP (HCU-form.005, pág. 23 del PDF oficial) pide por cada fármaco: DCI, dosis, vía,
// periodicidad y cantidad. La pauta que arma `RecetaWizard` ("1 tableta cada 8 horas por 7 días") ya trae dosis y
// periodicidad juntas; la vía no se guarda en el `MedicationRequest`, por eso el wizard la entrega aparte.
import type { MedicationRequest } from '@medplum/fhirtypes';
import type { Par } from './index';

export interface EtiquetasPrescripcion {
  /** "Prescripción" — se le antepone el número de orden. */
  readonly prescripcion: string;
  readonly dosisPeriodicidad: string;
  readonly via: string;
  readonly cantidad: string;
}

export function paresDePrescripciones(mrs: readonly MedicationRequest[], vias: readonly string[], desde: number, etiquetas: EtiquetasPrescripcion): Par[] {
  return mrs.map((mr, i) => {
    const pauta = mr.dosageInstruction?.[0]?.text?.trim();
    const via = vias[i]?.trim();
    const cantidad = mr.dispenseRequest?.quantity;
    const detalle = [
      pauta ? `${etiquetas.dosisPeriodicidad}: ${pauta}` : '',
      via ? `${etiquetas.via}: ${via}` : '',
      cantidad?.value !== undefined ? `${etiquetas.cantidad}: ${[cantidad.value, cantidad.unit].filter((x) => x !== undefined && x !== '').join(' ')}` : '',
    ].filter(Boolean);
    return {
      pregunta: `${etiquetas.prescripcion} ${desde + i + 1}: ${mr.medicationCodeableConcept?.text ?? ''}`.trim(),
      respuesta: detalle.join(' · ') || '—',
    };
  });
}
